/** Application-wide providers: i18n, data, API, theme (with company colour bridge), tooltips, toasts. Keyboard shortcuts are an admin-panel feature only. */
import { ToastProvider, TooltipProvider } from '@person-platform/ui';
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import type { i18n as I18nInstance } from 'i18next';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import type { ApiContextValue } from '../api/api_context';
import { ApiProvider } from '../api/api_provider';
import { ExportJobsProvider } from '../shared/export/export_jobs_provider';
import { BrandedThemeProvider } from './brand_color_context';

export interface AppProvidersProps {
  api: ApiContextValue;
  queryClient: QueryClient;
  i18n: I18nInstance;
  children: ReactNode;
}

export function AppProviders({ api, queryClient, i18n, children }: AppProvidersProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <ApiProvider value={api}>
          <BrandedThemeProvider>
            <TooltipProvider>
              <ToastProvider>
                <ExportJobsProvider>{children}</ExportJobsProvider>
              </ToastProvider>
            </TooltipProvider>
          </BrandedThemeProvider>
        </ApiProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}
